import { Title, Center } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { RoutePath, useNavigateToRoute } from 'utils/location';
import { PatientStatus } from 'utils/models';
import { CenteredLoading } from 'components/CenteredLoading';
import { useTotalPatients } from 'hooks/api/useUser';
import { InfoCard } from '../InfoCard/InfoCard';

export const WidgetTotalPatients = () => {
  const { t } = useTranslation();
  const { data: totalPatients, isLoading } = useTotalPatients();
  const navigateToRoute = useNavigateToRoute();

  return (
    <InfoCard
      title={t('dashboard_total_patients')}
      tooltip={t('dashboard_total_patients_tooltip')}
      onClick={() => navigateToRoute(RoutePath.Patients, { status: PatientStatus.All })}
      testId={'card-total-patients'}
    >
      <Center my={'xl'}>
        {<Title data-testid={'title-total-patients'}>{isLoading ? <CenteredLoading /> : totalPatients}</Title>}
      </Center>
    </InfoCard>
  );
};
